module.exports = __webpack_public_path__ + "img/monitoringdescription3.87ab8b55.png";